export default "__VITE_ASSET__BoMCQTNn__"